import React, { useState } from 'react';
import { Container } from '../ui/Container';
import { Button } from '../ui/Button';
import { INPUT_STYLES } from '../../Constants/Const';
import { useIsMobile } from '../../Hooks/useIsMobile';
import { toast } from 'sonner';
import { getImagePath } from '../../Utils/Utilities';

const HeroSection = ({ onGetStarted, onLogin, loading, isFromGQik = false, onBuyNow, logo = getImagePath('/Images/QikERP.png'), rfdAvl, flashOfferOn, isMidnight, isFromOfr = false }) => {
  const [mobileNumber, setMobileNumber] = useState('');
  const [error, setError] = useState('');
  const isMobile = useIsMobile();

  const handleInputChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    if (value.length <= 10) {
      setMobileNumber(value);
      setError('');
    }
  };

  const handleSubmit = (e, action) => {
    e.preventDefault();

    if (!mobileNumber) {
      toast.error('Please enter your mobile number');
      return;
    }

    if (mobileNumber.length !== 10) {
      toast.error('Please enter a valid 10-digit mobile number');
      return;
    }

    action === 'login' ? onLogin?.(mobileNumber) : onGetStarted?.(mobileNumber);
  };

  const featuresWithIcons = [
    { name: 'CRM', icon: 'fa fa-users' },
    { name: 'Quotes', icon: 'fas fa-file-alt' },
    { name: 'Orders', icon: 'fas fa-box' },
    { name: 'Billing', icon: 'fas fa-money-bill-wave' },
    { name: 'E-Way Bill', icon: 'fas fa-truck' },
    { name: 'E-Invoice', icon: 'fas fa-file-invoice' },
    { name: 'Accounts', icon: 'fas fa-inr' },
    // { name: 'GSTR1 & 3B', icon: 'fas fa-landmark' },
    { name: 'Recovery', icon: 'fas fa-hand-holding-usd' },
    { name: 'Inventory', icon: 'fas fa-warehouse' },
    // { name: 'Batches', icon: 'fas fa-layer-group' },
    // { name: 'BOM', icon: 'fas fa-clipboard-list' },
    // { name: 'Purchase Orders', icon: 'fa fa-shopping-cart' },
    // { name: 'Suppliers Invoices', icon: 'fas fa-user-tie' },
    // { name: 'MRP', icon: 'fas fa-calculator' },
    { name: 'Projects', icon: 'fas fa-project-diagram' },
    { name: 'Manufacturing', icon: 'fas fa-industry' },
    // { name: 'Tasks', icon: 'fas fa-tasks' },
    // { name: 'Support Ticketing', icon: 'fas fa-headset' },
    // { name: 'Contracts', icon: 'fas fa-file-contract' },
  ];


  return (
    <section id="hero-section" className={`${isFromGQik && isMobile ? 'min-h-[60vh]' : 'min-h-[70vh]'} bg-background-light md:min-h-screen flex items-center justify-center pt-6 px-4 md:py-0 overflow-hidden`}>
      {!isMobile ? (
        <div className="w-full max-w-[1600px] mx-auto px-8">
          <div className="grid grid-cols-2 gap-16 h-full items-center">
            {/* Left Column - Text and Form */}
            <div className="flex flex-col justify-center">
              {/* Main Heading */}
              <h1 className="text-5xl lg:text-6xl font-bold text-left !leading-[1.25] mb-12">
                <span className="text-primary">Easy</span> & <span className="text-primary">Powerful</span>
                <br />
                <span>Tools to</span>
                <br />
                <span className="text-primary">Accelerate Business</span>
              </h1>

              {/* Feature Tags */}
              <div className="mb-8 flex flex-wrap gap-3">
                {featuresWithIcons.map((feature, idx) => (
                  <div key={idx} className="flex items-center gap-2 border border-border rounded px-3 py-2 !bg-white">
                    <i className={`${feature.icon} flex-shrink-0 text-primary`} style={{ fontSize: '16px' }}></i>
                    <span className="text-sm text-text-primary font-bold">{feature.name}</span>
                  </div>
                ))}
              </div>

              {/* Desktop Input Form Label */}
              {!isFromGQik && (
                <h2 className="font-semibold text-text-primary mb-3">
                  Enter Mobile to Get Started
                </h2>
              )}

              {/* Mobile Input Form or Buy Now Buttons */}
              {isFromGQik ? (
                <div className="flex flex-col gap-2">
                  {rfdAvl && (
                    <span className="text-primary text-sm font-semibold mb-2">
                      7-day Moneyback Guarantee
                    </span>
                  )}
                  <div className="flex gap-3">
                    <Button
                      type="button"
                      variant="primary"
                      onClick={() => {
                        onBuyNow?.();
                        const pricingSection = document.getElementById('simplePricing');
                        if (pricingSection) {
                          pricingSection.scrollIntoView({ behavior: 'smooth' });
                        }
                      }}
                    >
                      Buy Now
                    </Button>
                    <Button
                      type="button"
                      variant="secondary"
                      onClick={() => {
                        onBuyNow?.();
                        const targetId = isFromOfr ? 'simplePricing' : 'demoSection';
                        const section = document.getElementById(targetId);
                        if (section) {
                          section.scrollIntoView({ behavior: 'smooth' });
                        }
                      }}
                    >
                      {isFromOfr ? 'Compare Plans' : 'Watch demo'}
                    </Button>
                  </div>
                  {flashOfferOn && (
                    <div className="text-red-600 font-bold mt-4 animate-pulse">
                      Flash Offer Ends Soon!
                    </div>
                  )}
                  {!flashOfferOn && isMidnight && (
                    <div className="text-red-600 font-bold mt-4 animate-pulse">
                      Midnight Sale Ends Soon! 🌜
                    </div>
                  )}
                </div>
              ) : (
                <form onSubmit={(e) => handleSubmit(e, 'start')}>
                  <div className="flex gap-3 max-w-[320px]">
                    <div className={`${INPUT_STYLES.wrapper} w-[220px]`}>
                      <input
                        type="tel"
                        id="mobile"
                        value={mobileNumber}
                        onChange={handleInputChange}
                        placeholder="Mobile Number"
                        maxLength="10"
                        className="w-full px-4 py-3 border-none outline-none focus:outline-none focus:ring-0 focus:border-transparent text-base bg-transparent"
                        required
                        disabled={loading}
                      />
                    </div>
                    <Button
                      type="submit"
                      variant="primary"
                      disabled={loading}
                    >
                      ➔
                    </Button>
                  </div>
                </form>
              )}
            </div>

            {/* Right Column - Images */}
            <div className="relative h-[80vh] flex items-center justify-start" style={{ width: '150%', marginLeft: '-25%' }}>
              {/* Desktop Screenshot with Frame */}
              <div style={{
                backgroundColor: '#eaeaea',
                borderRadius: '15px',
                padding: '7px',
                position: 'relative',
                right: '-30%',
                width: '100%',
                boxShadow: '5px 4px 11px rgba(0, 0, 0, 0.15)'
              }}>
                <img
                  src={getImagePath("/Images/GuideWebDB.png")}
                  alt="Dashboard"
                  style={{
                    height: 'auto',
                    maxHeight: '32rem',
                    objectFit: 'contain',
                    borderRadius: '10px',
                    display: 'block'
                  }}
                />
              </div>
              {/* Mobile Screenshot Overlay */}
              <img
                src={getImagePath("/Images/V3 without Shadow.png")}
                alt="Mobile App"
                className="absolute w-[21%] max-w-[280px] bottom-[8%] left-[22%] rounded-3xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      ) : (
        <Container variant={isFromGQik ? "wide" : "container"}>
          {/* Logo */}
          {isMobile ? (
            <div className="flex flex-col items-center mb-12 relative">
              <img
                src={logo}
                alt="Logo"
                className={`${logo.includes('Biziverse.png') ? 'h-[70px]' : 'h-[120px]'} w-auto object-contain mt-5`}
              />
              {!logo.includes('Biziverse.png') && (
                <div className="flex flex-col items-center absolute top-[110px]" style={{ right: '5.25rem' }}>
                  <span className="text-sm text-primary font-bold mb-0.5">by</span>
                  <img
                    src={getImagePath("/Images/Biziverse.png")}
                    alt="Biziverse"
                    className="h-[26px] w-auto object-contain"
                  />
                </div>
              )}
            </div>
          ) : null}
          {/* Main Heading */}
          <h1 className={`text-[24px] sm:text-4xl md:text-5xl lg:text-5xl font-bold text-center mt-[4rem] px-5 ${isFromGQik ? 'mb-12 md:mb-12' : 'mb-12 md:mb-16'}`}>
            <span className="text-primary">Easy</span> & <span className="text-primary">Powerful</span><br className="md:hidden" /> Tools to <span className='text-primary'><br className="md:hidden" />Accelerate Business</span>
          </h1>
          {/* Two Column Layout */}
          <div className={`grid grid-cols-1 ${isFromGQik ? 'md:grid-cols-[1fr,1fr]' : 'md:grid-cols-2'} gap-4 ${isFromGQik ? 'md:gap-16 lg:gap-24' : 'md:gap-12 lg:gap-16'} ${isFromGQik ? 'items-start' : 'items-center'}`}>
            {/* Left Side - Signup Card or Pricing Info */}
            <div className={`w-full max-w-md mx-auto order-2 md:order-1 ${isFromGQik ? 'md:ml-0 md:mr-auto' : 'md:mx-0'}`}>
              {isFromGQik && isMobile ? (
                <>
                  {/* <div className="flex flex-col gap-3 w-full px-4">
                    <Button
                      type="button"
                      variant="primary"
                      onClick={() => {
                        onBuyNow?.();
                        const pricingSection = document.getElementById('simplePricing');
                        if (pricingSection) {
                          pricingSection.scrollIntoView({ behavior: 'smooth' });
                        }
                      }}
                    >
                      Buy Now
                    </Button>
                    <Button
                      type="button"
                      variant="secondary"
                      onClick={() => {
                        onBuyNow?.();
                        const targetId = isFromOfr ? 'simplePricing' : 'demoSection';
                        const section = document.getElementById(targetId);
                        if (section) {
                          section.scrollIntoView({ behavior: 'smooth' });
                        }
                      }}
                    >
                      {isFromOfr ? 'Compare Plans' : 'Watch demo'}
                    </Button>
                  </div> */}
                </>
              ) : (
                <div className="md:bg-transparent md:border-0 md:p-0 bg-background-light border-2 border-border rounded p-6 sm:p-8">
                  <form onSubmit={(e) => handleSubmit(e, 'start')}>
                    <h2 className="text-base md:text-lg font-semibold text-text-primary mb-6 text-center md:hidden">
                      Enter Mobile to Get Started
                    </h2>

                    {/* Mobile Input */}
                    <div className="flex gap-2 md:gap-3">
                      <div className={`${INPUT_STYLES.wrapper} flex-1 md:max-w-[220px]`}>
                        <input
                          type="tel"
                          id="mobile"
                          value={mobileNumber}
                          onChange={handleInputChange}
                          placeholder="Mobile Number"
                          maxLength="10"
                          className="w-full px-4 py-3 border-none outline-none focus:outline-none focus:ring-0 focus:border-transparent text-base bg-transparent text-center md:text-left placeholder:text-center"
                          required
                          disabled={loading}
                        />
                      </div>
                      {!isMobile ? <Button
                        type="submit"
                        variant="primary"
                        disabled={loading}
                      >
                        ➔
                      </Button> : null}
                    </div>

                    {/* Mobile-only Buttons */}
                    <div className="flex gap-3 mt-6 md:hidden">
                      <Button
                        type="button"
                        variant="primary"
                        onClick={(e) => handleSubmit(e, 'login')}
                        className="flex-1 text-base py-3"
                        disabled={loading}
                      >
                        Login
                      </Button>
                      <Button
                        type="submit"
                        variant="primary"
                        className="flex-1 text-base py-3"
                        disabled={loading}
                      >
                        Start Now
                      </Button>
                    </div>
                  </form>
                </div>
              )}
            </div>
            {/* Right Side - Device Showcase */}
            <div className={`relative w-full order-1 md:order-2 ${isFromGQik ? 'mb-12 md:mb-0 md:mt-8' : 'mb-16 md:mb-0'}`}>
              <div className="relative w-full">
                {/* Desktop Screenshot */}
                <img
                  src={getImagePath("/Images/GuideWebDB.png")}
                  alt="Dashboard"
                  className={`w-[92%] mx-auto h-auto border-4 border-gray-200 rounded shadow-lg md:w-full md:border-0 md:shadow-2xl ${isFromGQik ? 'md:scale-150 md:origin-center' : 'md:scale-110 md:origin-right md:translate-x-[25%]'}`}
                />
                {/* Mobile Screenshot Overlay */}
                <img
                  src={getImagePath("/Images/V3 without Shadow.png")}
                  alt="Mobile App"
                  className={`absolute rounded shadow-heavy z-10 w-[27%] max-w-[150px] bottom-[-32px] right-[2rem] md:w-[30%] md:max-w-[200px] md:bottom-[-34px] md:right-[-12%] md:left-auto lg:bottom-[-60px] lg:right-[-20%]`}
                />
              </div>
            </div>
          </div>
        </Container>
      )}
    </section>
  );
};

export default HeroSection;
